import React from "react"
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { styles } from "./style";

interface Props extends
	WithStyles<typeof styles> {
	label: string,
	placeholder?: string,
	value?: string,
	errorText?: string | false,
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
	sidebarNote?: string,
	maxWidth?: number,
}

class Component extends React.Component<Props> {
	public render() {
		const { classes = {}, onChange, value, errorText, label, placeholder, maxWidth } = this.props;

		return (
			<Mui.Grid container direction="row" spacing={2}>
				<Mui.Grid item xs={12} sm className={maxWidth ? classes.fieldContainer : undefined}>
					<Mui.TextField
										label={label}
										placeholder={placeholder}
										helperText={errorText}
										error={!!errorText}
										FormHelperTextProps={{
											className: classes.errorMessage
										}}
										variant="outlined"
										value={value}
										onChange={onChange}
										InputLabelProps={{ shrink: true }}
										fullWidth />
				</Mui.Grid>
				
					{ this.props.sidebarNote !== undefined &&
					<Mui.Grid item xs={12} sm={6}>
						<div>
							<strong>Note: </strong> {this.props.sidebarNote}
						</div>
						</Mui.Grid>
					}
				
			</Mui.Grid>
		);
	}
}

export const FullWidthField = withStyles(Component, styles)